import { render, staticRenderFns } from "./PdfOverlay.vue?vue&type=template&id=b61318da&"
import script from "./PdfOverlay.vue?vue&type=script&lang=js&"
export * from "./PdfOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports